import axiosClient from "../axiosInstance";

const base = "/players";
// Admin-only player management (correct, delete, merge).
const adminBase = "/admin/players";

export const getAllPlayers = async () => {
  const response = await axiosClient.get(`${base}`);
  return response.data;
};

export const getPlayerById = async (playerId) => {
  const response = await axiosClient.get(`${base}/${playerId}`);
  return response.data;
};

export const getPlayerByBSANumber = async (bsaNumber) => {
  const response = await axiosClient.get(`${base}/by-bsa/${bsaNumber}`);
  return response.data;
};

export const lookupPlayerByBSANumber = async (bsaNumber) => {
  const response = await axiosClient.get(`${base}/lookup-by-bsa/${bsaNumber}`);
  return response.data;
};

export const createPlayer = async (playerData) => {
  const response = await axiosClient.post(`${base}`, playerData);
  return response.data;
};

export const updatePlayer = async (playerId, playerData) => {
  const response = await axiosClient.patch(`${base}/${playerId}`, playerData);
  return response.data;
};

export const deletePlayer = async (playerId) => {
  const response = await axiosClient.delete(`${base}/${playerId}`);
  return response.data;
};

export const getPlayersWithPagination = async (page, limit, search = "") => {
  const response = await axiosClient.get(`${base}/search`, {
    params: { page, limit, search },
  });
  return response.data;
};

/**
 * The player with their entry count and member-account link - what the delete
 * dialog shows before anything is destroyed.
 */
export const getPlayerSummary = async (playerId) => {
  const response = await axiosClient.get(`${adminBase}/${playerId}`);
  return response.data;
};

export const updatePlayerAdmin = async (playerId, playerData) => {
  const response = await axiosClient.patch(
    `${adminBase}/${playerId}`,
    playerData,
  );
  return response.data;
};

/** Deletes the player AND every entry they hold. Irreversible. */
export const deletePlayerAdmin = async (playerId, bsaNumber) => {
  const response = await axiosClient.delete(`${adminBase}/${playerId}`, {
    data: { bsaNumber },
  });
  return response.data;
};

/** Read-only: entry counts and the collisions a merge would create. */
export const mergePlayersPreview = async (sourceId, targetId) => {
  const response = await axiosClient.post(`${adminBase}/merge/preview`, {
    sourceId,
    targetId,
  });
  return response.data;
};

/** Moves every entry from sourceId to targetId, then deletes sourceId. */
export const mergePlayers = async ({ sourceId, targetId, bsaNumber }) => {
  const response = await axiosClient.post(`${adminBase}/merge`, {
    sourceId,
    targetId,
    bsaNumber,
  });
  return response.data;
};

const playerService = {
  getAllPlayers,
  getPlayerById,
  getPlayerByBSANumber,
  lookupPlayerByBSANumber,
  createPlayer,
  updatePlayer,
  deletePlayer,
  getPlayersWithPagination,
  getPlayerSummary,
  updatePlayerAdmin,
  deletePlayerAdmin,
  mergePlayersPreview,
  mergePlayers,
};

export default playerService;
